import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { PdfInfo } from 'src/app/core/model/pdf-info';
import { PdfService } from 'src/app/core/services/shared/pdf.service';

@Component({
  selector: 'app-view-pdf',
  templateUrl: './view-pdf.component.html',
  styleUrls: ['./view-pdf.component.css']
})
export class ViewPdfComponent implements OnInit {

  zoomValue: number = 1;

  pdfTotalPages: number;
  pdfRenderPage: number;

  checkBoxGroup = new FormControl();
  enabledCheck: boolean = false;

  @Output()
  checkAccept = new EventEmitter();

  @Output()
  errorPdf = new EventEmitter();

  @Input()
  textAcceptButton: string;

  @Input()
  pdfSrc;

  pdfButtons: string[];

  openModal:boolean = false;

  error:boolean = false

  pdfFile: Uint8Array;

  constructor(private service: PdfService) { }

  ngOnInit(): void {
    this.pdfButtons = [
      "expand",
      "zoom-plus",
      "zoom-minus"
    ]
    this.convertPdfFile();
  }

  pageRendered(info: PdfInfo) {
    this.pdfRenderPage = info.pageNumber
    if(this.pdfRenderPage == this.pdfTotalPages){
      this.enabledCheck = true;
    }
  }

  pageInitialized(info: PdfInfo) {
    this.pdfTotalPages = info.source.pdfDocument._pdfInfo.numPages
  }

  changeCheckAccept(isCheck: boolean){
    this.checkAccept.emit(isCheck)
  }

  clickPdfButton(typeButton:string){
    const zoomNumber = 0.25
    switch (typeButton){
      case this.pdfButtons[0]:
        this.openModal = true;
        break;
      case this.pdfButtons[1]:
        this.zoomValue = this.zoomValue + zoomNumber
        break;
      case this.pdfButtons[2]:
        this.zoomValue = this.zoomValue - zoomNumber
        break;
    }
  }

  closeModal(){
    this.openModal = false;
  }

  callErrorPdf(error: any) {
    this.error = true
    this.errorPdf.emit(error)
 }
    
  convertPdfFile() {
    this.service.getPDF(this.pdfSrc).then( data => {
      const fileReader = new FileReader();
        fileReader.onload = () => {
            this.pdfFile = new Uint8Array(fileReader.result as ArrayBuffer);
        };
        fileReader.readAsArrayBuffer(data);     
    }).catch(err => {
      this.callErrorPdf(err);
    });
  }

}
